import React from 'react';
import PropTypes from 'prop-types';
import withStyles from '@mui/styles/withStyles';
import Autosuggest from 'react-autosuggest';
import TextField from '@mui/material/TextField';
import MenuItem from '@mui/material/MenuItem';

import IconButton from '@mui/material/IconButton';
import ResetIcon from '@mui/icons-material/Cancel';
import InputAdornment from '@mui/material/InputAdornment';
import debounce from 'lodash/debounce';


const MinimalLength = 1;

const styles = {
    container: {
        flexGrow: 1,
        position: 'relative'
    },
    suggestionsContainerOpen: {
        position: 'absolute',
        zIndex: 2,
        marginTop: 10,
        maxHeight: '300px',
        overflowY: 'auto',
        backgroundColor: '#fff',
        border: '1px solid #aaa'
    },
    suggestion: {
        display: 'block'
    },
    suggestionsList: {
        margin: 0,
        padding: 0,
        listStyleType: 'none'
    }
};

class TransporteurSearch extends React.Component {
    state = {
        isLoading: false
    };

    renderInput = inputProps => {
        const { classes, ref, disabled, onClickReset, ...other } = inputProps;
        const { isRequired, error } = this.props;

        return (
            <TextField
                fullWidth
                required={isRequired}
                error={error !== undefined}
                label="Transporteur"
                placeholder="Rechercher un transporteur"
                helperText={error ? error.errorMsg : ''}
                InputLabelProps={{
                    shrink: true
                }}
                InputProps={{
                    inputRef: ref,
                    classes: {
                        input: classes.input
                    },
                    disabled,
                    endAdornment: disabled &&   <InputAdornment position={'end'}>
                                                    <IconButton onClick={onClickReset} size="large"><ResetIcon /></IconButton>
                                                </InputAdornment >,
                    ...other
                }}
            />
        );
    }

    renderSuggestionsContainer(options) {
        const { containerProps, children } = options;

        return (
            <div {...containerProps} >
                {children}
            </div>
        );
    }

    handleSuggestionsFetchRequested = debounce(({ value }) => {
        if (value.length >= MinimalLength) {
            const { onSearch } = this.props;

            this.setState({
                isLoading: true
            });

            onSearch(value);

            this.setState({
                isLoading: false
            });
        }
    }, 300);

    handleSuggestionsClearRequested = () => {
        const { onClear } = this.props;

        onClear();
    };

    handleChange = (event, { newValue, method }) => {
        const { onChange } = this.props;

        onChange(newValue);
    };

    handleSuggestionSelected = (event, { suggestion, suggestionValue, suggestionIndex, sectionIndex, method }) => {

        const { onSuggestionSelected } = this.props;

        onSuggestionSelected(suggestion.id, suggestion.code + " - " + suggestion.nom);
    }

    handleBlur = (event, { highlightedSuggestion }) => {
        const { onSuggestionSelected, selectedId } = this.props;

        if (selectedId === 0) {
            onSuggestionSelected(0, '');
        }
    };



    handleClickReset = () => {
        const { onSuggestionSelected } = this.props;
        onSuggestionSelected(0, '');
    }

    getSuggestionValue = (suggestion) => {
        return suggestion.code + " - " + suggestion.nom;
    }

    renderSuggestion(suggestion, { query, isHighlighted }) {
        return (
            <MenuItem selected={isHighlighted} component="div" >
                {suggestion.code} - {suggestion.nom}
            </MenuItem>
        );
    }

    render() {
        const { classes, transporteurs, selectedId } = this.props;

        return (
            <Autosuggest
                theme={{
                    container: classes.container,
                    suggestionsContainerOpen: classes.suggestionsContainerOpen,
                    suggestionsList: classes.suggestionsList,
                    suggestion: classes.suggestion
                }}
                renderInputComponent={this.renderInput}
                suggestions={transporteurs}
                onSuggestionsFetchRequested={this.handleSuggestionsFetchRequested}
                onSuggestionsClearRequested={this.handleSuggestionsClearRequested}
                renderSuggestionsContainer={this.renderSuggestionsContainer}
                getSuggestionValue={this.getSuggestionValue}
                renderSuggestion={this.renderSuggestion}
                onSuggestionSelected={this.handleSuggestionSelected}
                inputProps={{
                    classes,
                    value: this.props.value,
                    onChange: this.handleChange,
                    onBlur: this.handleBlur,
                    disabled: selectedId !== 0,
                    onClickReset: this.handleClickReset
                }}
            />
        );
    }
}

TransporteurSearch.propTypes = {
    transporteurs: PropTypes.array.isRequired,
    onSearch: PropTypes.func.isRequired,
    onChange: PropTypes.func.isRequired,
    onClear: PropTypes.func.isRequired,
    isRequired: PropTypes.bool.isRequired,
    error: PropTypes.object,
    onSuggestionSelected: PropTypes.func.isRequired,
    value: PropTypes.string.isRequired,
    selectedId: PropTypes.number.isRequired
};

export default withStyles(styles)(TransporteurSearch);